import {Injectable} from '@angular/core';
import {LogLevel, LogResource} from '@app/modules/shared/data/constants';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  static enableTrackReceiveStopLogs = true;

  constructor() {}

  public static writeLog(message: string, level: LogLevel, logResource: LogResource) {
    switch (level) {
      case LogLevel.ERROR:
        console.error(LogResource[logResource] + ': ' + new Date().toJSON() + ': ' + message + '.');
        break;
      case LogLevel.WARN:
        console.warn(LogResource[logResource] + ': ' + new Date().toJSON() + ': ' + message + '.');
        break;
      default:
        console.log(LogResource[logResource] + ': ' + new Date().toJSON() + ': ' + message + '.');
    }
  }

  static writeGetTrackLog(trackId, deviceId, deviceType) {
    if (this.enableTrackReceiveStopLogs) {
      this.writeLog(`Get ${deviceType} track by id ${trackId} device id ${deviceId}`, LogLevel.DEBUG, LogResource.WRTC);
    }
  }

  static writeStopTrackLog(trackId, deviceId, deviceType) {
    if (this.enableTrackReceiveStopLogs) {
      this.writeLog(`Stop ${deviceType} track by id ${trackId} device id ${deviceId}`, LogLevel.DEBUG, LogResource.WRTC);
    }
  }

  public static getStyleByLevel(logLevel) {
    return logLevel === LogLevel.ERROR ? 'color: ##ff0000' : '';
  }
}
